import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import YangoDeliveryForm from './YangoDeliveryForm';
import Modal from '../../../../common/modal/Modal';
import { patchStartDelivery, postYangoDelivery } from '../../../../../actions';

export const YangoDeliveryButton = ({
  deliveryId,
  dispatchPostYangoDelivery,
  dispatchPatchStartDelivery,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState(null);

  const onModalSubmit = async ({ comment }) => {
    const response = await dispatchPostYangoDelivery(deliveryId, { comment });

    if (response) {
      dispatchPatchStartDelivery({ deliveryId });
    }
  };

  const onCancel = () => {
    setShowModal(false);
  };

  const onShowModal = () => {
    const newModalBody = (
      <YangoDeliveryForm
        onCancel={onCancel}
        onSubmit={onModalSubmit}
        deliveryId={deliveryId}
      />
    );
    setModalBody(newModalBody);
    setShowModal(true);
  };

  return (
    <>
      <Button color="warning" onClick={onShowModal}>
        <i className="fa fa-truck" /> Cotizar Entrega Yango
      </Button>
      <Modal
        show={showModal}
        title="Comenzar Entrega Yango"
        body={modalBody}
        size="lg"
        onClickClose={onCancel}
        onClickCancel={onCancel}
      />
    </>
  );
};

YangoDeliveryButton.propTypes = {
  deliveryId: PropTypes.number.isRequired,
  dispatchPostYangoDelivery: PropTypes.func.isRequired,
  dispatchPatchStartDelivery: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostYangoDelivery: postYangoDelivery,
  dispatchPatchStartDelivery: patchStartDelivery,
};

export default connect(null, mapDispatchToProps)(YangoDeliveryButton);
